import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import Header from "./components/Header/Header";

const HEADER_HEIGHT = 64;

const Layout = () => {
  return (
    <>
      <Header />
      <Box
        sx={{
          pt: `${HEADER_HEIGHT}px`,
          minHeight: `calc(100vh - ${HEADER_HEIGHT}px)`,
        }}
      >
        <Outlet />
      </Box>
    </>
  );
};

export default Layout;
